import * as swcHelpers from '@swc/helpers';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToReadyReaderVariant } from '../variant-mappers/map-server-to-ready-reader-variant.js';
import { mapServerToProductBase } from './map-server-to-product-base.js';

const mapServerToReadyReaderProduct = (serverProduct, slug, locale, facetConfigList)=>{
    if ((serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename) !== 'ReadyReaderProduct') {
        return {
            failure: 'incorrect-typename',
            message: `Expected ReadyReaderProduct for slug "${slug}", but got ${serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename}`
        };
    }
    const variants = mapServerToReadyReaderVariant(serverProduct, slug, locale);
    if (!variants || variants.length === 0) {
        return {
            failure: 'no-variants',
            message: `Cannot return Ready Reader product with slug: "${slug}" because it has no variants`
        };
    }
    return swcHelpers.objectSpread({}, mapServerToProductBase(serverProduct, variants, facetConfigList), {
        productType: 'Ready-readers',
        variants,
        isOfferedWithPrescriptions: false
    });
};

export { mapServerToReadyReaderProduct };
//# sourceMappingURL=map-server-to-ready-reader-product.js.map
